import { render, staticRenderFns } from "./RemoteUpgrade.vue?vue&type=template&id=2f93bba4"
import script from "./RemoteUpgrade.vue?vue&type=script&lang=js"
export * from "./RemoteUpgrade.vue?vue&type=script&lang=js"
import style0 from "./RemoteUpgrade.vue?vue&type=style&index=0&id=2f93bba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports